import { useContext, useEffect } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { AuthContext } from "../Contexts/AuthContext";
import { AuthModalContext } from "../Contexts/AuthModalContext";

const CustomerRoute = () => {
    let location = useLocation();
    const { isAuthenticated } = useContext(AuthContext);
    const { openSignIn } = useContext(AuthModalContext);

    // there is no login page to bounce to any more: open the modal over the home
    // page and come back to the guarded route once they are signed in
    useEffect(() => {
        if (!isAuthenticated) {
            openSignIn({ redirectTo: location.pathname + location.search });
        }
    }, [isAuthenticated, location.pathname, location.search, openSignIn]);

    return isAuthenticated ? <Outlet /> : <Navigate to="/" state={{ from: location }} replace />;
};

export default CustomerRoute;
